export const TABLE_PAGE_SIZE = 10;

export const antTablePagination = {
  pageSize: TABLE_PAGE_SIZE,
  showSizeChanger: false,
} as const;

export const antTableScroll = { x: 'max-content' } as const;
